import React from "react";

import { TagCategoryTableActions } from "./TagCategoryTableActions";

export const getTagCategoryTableColumns = ({ onSuccess }) => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
      size: 200,
    },
    {
      header: "Description",
      id: "Description",
      accessorKey: "description",
    },
    {
      header: null,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <TagCategoryTableActions
          original={row.original}
          onSuccess={onSuccess}
        />
      ),
    },
  ];
};

export const getTagCategoryTableFilters = () => {
  return [];
};
